import * as React from 'react';
import * as styles from './spinner.module.css';
import { clsx } from 'clsx';

type Props = React.ComponentPropsWithoutRef<"div"> & {
	dotAmount?: number,
	color?: SpinnerColorsEnum,
}

export enum SpinnerColorsEnum {
	Primary = '',
	White = 'dotWhite',
	Black = 'dotBlack',
}

function Spinner({className = '', dotAmount = 6, color = SpinnerColorsEnum.Primary, ...otherProps}: Props) {
	return (
		<div className={clsx(styles.spinner, className)} {...otherProps}>
			{[...Array(dotAmount)].map((el, i) => {
				return <div key={'dot' + i} className={clsx(styles.dot, color !== SpinnerColorsEnum.Primary && styles[color])}/>;
			})}
		</div>
	);
}

export default Spinner;
